import styled from "styled-components";
import { LeftOutline } from "antd-mobile-icons";
import { useNavigate } from "react-router-dom";
import { useEffect } from "react";
import { useState } from "react";
export default function NavBar({ title, Right, onClick }) {
  const navigate = useNavigate();
  const [top, setTop] = useState(0);
  const onScroll = () => {
    setTop(
      window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop
    );
  };
  useEffect(() => {
    window.addEventListener("scroll", onScroll);
    return () => {
      window.removeEventListener("scroll", onScroll);
    };
  }, []);
  return (
    <Wrapper top={top}>
      <LeftIcon
        onClick={() => {
          if (onClick) {
            onClick();
          } else {
            let urls = window.localStorage.getItem("RUNBUT_PATHS");
            urls = JSON.parse(urls);
            if (urls && urls.length) {
              const { url } = urls.pop();
              console.log("url", url,urls);
              window.localStorage.setItem('RUNBUT_PATHS',JSON.stringify(urls))
              navigate(url,{
                replace: true
              });
            } else {
              navigate('/')
            }
          }
        }}
      >
        <LeftOutline fontSize={16} />
      </LeftIcon>
      <Titel>{title}</Titel>
      <div></div>
      {Right ? (
        <RightIcon>
          <Right />
        </RightIcon>
      ) : null}
    </Wrapper>
  );
}

const Wrapper = styled.div`
  text-align: center;
  margin-bottom: 1.6rem;
  /* margin-top:1.6rem; */
  padding: 1.3rem 2.0rem;
  background-color: ${(props) => (!props.top ? "" : "#f9f9f9")};
  position: -webkit-sticky;
  position: sticky;
  top: 0;
  z-index: 200;
  /* position: relative; */
`;

const LeftIcon = styled.div`
  position: absolute;
  left: 2.0rem;
  top: 1.3rem;
  bottom: 1.3rem;
  width: 3.0rem;
  height: 3.0rem;
  /* box-shadow: .05rem .05rem .0rem #000; */
  border: 1px solid #000;
  border-radius: 50%;
  font-size: 2.0rem;
  display: flex;
  align-items: center;
  justify-content: center;
`;
const Titel = styled.div`
  font-style: normal;
  font-weight: 600;
  font-size: 1.8rem;
  line-height: 3.2rem;
  color: #000000;
  display: inline-block;
  margin: 0 -3.0rem;
`;

const RightIcon = styled.div`
  position: absolute;
  right: 2.0rem;
  top: 1.3rem;
  bottom: 1.3rem;
  width: 3.0rem;
  height: 3.0rem;
  * {
    width: 100%;
  }
`;
